import { memo } from 'react';
import { Button, Grid, Typography, Theme } from '@quillbot/design-system';
import { fontSize, fontWeight, UNITS, w100p, unitPX } from 'src/researcher/styles';
import { ArrowRightIcon } from 'src/researcher/component/icons';
import researcherTrack from 'src/researcher/handlers/track';
import { openDrawer } from '@Common/handlers/services';
import FeedbackDrawer from '@Common/components/drawer/FeedbackDrawer';
import { TemplateCard } from './TemplateCard';
import { blankTemplate } from './types';
import { common_styles, pageStyles } from './styles.css';
import { useSliderVisibility } from './Slider';
import { useTemplateDemoState } from './template.store';

const styles = {
  topCtrlColor: {
    color: '#686868',
  },
  btn: {
    minWidth: 'unset',
    minHeight: 'unset',
    py: unitPX(UNITS['1px'] * 2),
    px: unitPX(UNITS['0.5pt']),
  },
};

function ViewMoreButton() {
  const [o, setSliderVisible] = useSliderVisibility();
  return (
    <Button
      variant="text"
      endIcon={<ArrowRightIcon />}
      sx={fontSize[14]}
      onClick={() => setSliderVisible('templates')}
    >
      View all Templates
    </Button>
  );
}

function TemplatesComponent() {
  const templates = useTemplateDemoState();
  return (
    <Grid item component="section" sx={[w100p, pageStyles.maxPageWidth]}>
      <Grid container direction="column">
        <Grid container item xs={12} justifyContent="space-between">
          <Grid item>
            <Typography component="h3" sx={[fontSize[20], fontWeight[400]]}>
              Start New
            </Typography>
          </Grid>
          <Grid item>
            <Button
              variant="text"
              size="small"
              sx={[fontSize[14], styles.topCtrlColor, styles.btn]}
              onClick={() => {
                researcherTrack.openedFeedback();
                openDrawer('FEEDBACK', FeedbackDrawer);
              }}
            >
              Feedback
            </Button>
            <Grid component="span" sx={[fontSize[14], styles.topCtrlColor]}>
              &nbsp;|&nbsp;
            </Grid>
            <Button
              variant="text"
              size="small"
              sx={[fontSize[14], styles.topCtrlColor, styles.btn]}
              onClick={() => {
                researcherTrack.clickedHelp('Landing Page', 'FAQs');
                window.open(
                  'https://help.quillbot.com/hc/en-us/categories/4615487286551-Co-Writer',
                  '_blank'
                );
              }}
            >
              Learn More
            </Button>
          </Grid>
        </Grid>
        <Grid
          container
          item
          xs={12}
          flex={1}
          sx={common_styles.contentPadding}
          justifyContent="space-between"
        >
          <TemplateCard
            isLastItem={false}
            // eslint-disable-next-line no-underscore-dangle
            isBlank
            {...blankTemplate}
          />
          {templates.map((template, index) => (
            <TemplateCard
              // eslint-disable-next-line no-underscore-dangle
              key={template._id}
              isLastItem={index === templates.length - 1}
              {...template}
            />
          ))}
        </Grid>
      </Grid>
      {/* view more button */}
      {/* <Grid container justifyContent="flex-end">
        <ViewMoreButton />
      </Grid> */}
    </Grid>
  );
}

export const TemplateDemoView = memo(TemplatesComponent);
